import { ComponentPropsWithoutRef } from "react";
import cn from "../util/cn";

type SkeletonTextLineProps = {
  className?: string;
} & Omit<ComponentPropsWithoutRef<"div">, "children">;

const SkeletonTextLine = ({ className, ...otherProps }: SkeletonTextLineProps) => (
  <div className={cn("animate-pulse rounded-full bg-gray-300", className)} {...otherProps}></div>
);

export default SkeletonTextLine;
